import { createTheme } from '@mui/material/styles'

const base = {
  spacing: (factor) => (factor === 'auto' ? 'auto' : `${0.25 * factor}rem`),
  typography: {
    fontSize: 14,
    htmlFontSize: 16,
    fontFamily: 'Segoe UI',
  },
}

const components = {
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
    },
  },
  MuiTab: {
    defaultProps: {
      disableRipple: true,
    },
  },
}

export const theme = createTheme({
  ...base,
  palette: {
    primary: {
      main: '#067153',
    },
    secondary: {
      main: '#DE0D65',
    },
  },
  components,
})

// Dark mode (see src/stores/useUIStore.js): the same navy as the CSS tokens in
// src/app/dark.css, so MUI dialogs, menus, inputs and tables match the Tailwind pages.
export const darkTheme = createTheme({
  ...base,
  palette: {
    mode: 'dark',
    primary: { main: '#7b89ec', contrastText: '#ffffff' },
    secondary: { main: '#f472b6' },
    success: { main: '#34d399' },
    warning: { main: '#fbbf24' },
    error: { main: '#f87171' },
    background: { default: '#0e1322', paper: '#151c31' },
    text: { primary: '#e8ecf8', secondary: '#9aa4bf' },
    divider: 'rgba(148, 163, 214, 0.16)',
  },
  components: {
    ...components,
    MuiCssBaseline: {
      styleOverrides: {
        body: { backgroundColor: 'var(--ods-bg)', color: 'var(--ods-text)' },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none', border: '1px solid rgba(148, 163, 214, 0.14)' },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { backgroundColor: '#151c31', boxShadow: '0 24px 60px rgba(0,0,0,.55), 0 0 0 1px rgba(123,137,236,.18)' },
      },
    },
    MuiBackdrop: {
      styleOverrides: { root: { backgroundColor: 'rgba(5, 8, 18, 0.7)' } },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { backgroundColor: '#10172a' },
        notchedOutline: { borderColor: 'rgba(148, 163, 214, 0.24)' },
      },
    },
    MuiTableCell: {
      styleOverrides: { root: { borderColor: 'rgba(148, 163, 214, 0.12)' } },
    },
    MuiTooltip: {
      styleOverrides: { tooltip: { backgroundColor: '#1e2742', color: '#e8ecf8', border: '1px solid rgba(148,163,214,.2)' } },
    },
  },
})
